import React from 'react';
import styled from 'styled-components';

import { SkeletonBlock } from '@/components/common';
import { media } from '@/styles/theme';

const ContractSelectSkeleton = (): React.ReactElement => <SkeletonContent />;

export { ContractSelectSkeleton };

const SkeletonContent = styled(SkeletonBlock)`
  height: 49px;
  margin-top: 36px;

  ${media.tablet} {
    margin-top: 0;
  }
`;
